import {IntermediatePart} from "../../intermediatePart";
import CenterIsland from "../../parts/centerIsland";

export default class Decor3 extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'decor_3';
    this.partName = 'Decor3';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Decor3());
  }

  setLayers(layout) {
    const centerIslandParent = this.getParent().layout.parts[CenterIsland.id];
    const cabinet = centerIslandParent.cabinet;

    if (cabinet && (cabinet.disabled || !cabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.Decor3;
    }
  }
}